<template>
  <div class="cart-wrap-top">
    <regular-item :item="item" v-if="item.item_type !== 'combo_item'" />
    <combo-item :item="item" v-else></combo-item>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import RegularItem from './RegularItem'
import ComboItem from './ComboItem'
export default {
  props: { item: Object },
  components: {
    ComboItem,
    RegularItem,
  },
  data() {
    return {
      isModalVisible: false,
    }
  },
  computed: {
    ...mapActions(['removeItemFromCart']),
    ...mapGetters(['_T', '_T_DB', 'hasModifiers', 'item_modifiers_price']),
  },
  methods: {
    showModal() {
      this.isModalVisible = true
      this.$store.commit('SELECT_ITEM', this.item)
      this.$store.commit('SET_ITEM_DETAIL_POPUP', this.isModalVisible)
    },
  },
}
</script>
